<template>
  <div class="rfp-table-list padding-t-20 k-page">
    <Table border :columns="tblColumns" :data="tblData" class="rfp-list-table k-table" :loading="isLoading" :no-data-text="(searchedText)? 'The RFP number doesn\'t exist, kindly recheck the number.':'No RFP yet'"></Table>
    <div style="margin: 10px;overflow: hidden" v-if="totalData > 20">
      <div style="float: right;">
        <Page :total="totalData" :current="curPage" @on-change="handleChangePage" :page-size="20"></Page>
      </div>
    </div>
    <RfpSummaryModal ref="RfpSummaryModal"/>
  </div>
</template>

<script>
import moment from 'moment'
import RfpSummaryModal from '@/components/rfp-list/SummaryModal'
import { fetchRfps } from '@/services/rfps'

export default {
  components: {
    RfpSummaryModal
  },

  props: {
    searchText: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      totalData: null,
      searchedText: this.searchText,
      curPage: 1,
      isLoading: false,
      tblColumns: [
        {
          title: 'Date Submitted',
          key: 'created_at',
          render: (h, params) => {
            return h('span', moment(params.row.created_at).format('MM/DD/YYYY'))
          }
        },
        {
          title: 'Deadline',
          key: 'deadline',
          render: (h, params) => {
            return h('span', moment(params.row.deadline).format('MM/DD/YYYY'))
          }
        },
        {
          title: 'RFP Number',
          key: 'rfp_number',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text'
                },
                style: {
                  marginRight: '5px',
                  color: '#2d8cf0'
                },
                on: {
                  click: () => {
                    this.$refs.RfpSummaryModal.openModal(params.row.id)
                  }
                }
              }, params.row.rfp_number)
            ])
          }
        },
        {
          title: 'Status',
          key: 'rfp_message_status',
          render: (h, params) => {
            let color = '#515a6e'
            if (params.row.rfp_message_status === 'Closed') {
              color = '#ed4014'
            } else if (params.row.rfp_message_status === 'Replied') {
              color = '#19be6b'
            } else if (params.row.rfp_message_status === 'Not yet replied') {
              color = '#515a6e'
            }
            return h('div', [
              h('span', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                style: {
                  color: color
                }
              }, params.row.rfp_message_status)
            ])
          }
        },
        {
          title: 'Action',
          key: 'action',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            let isDisabled = false
            if (params.row.rfp_message_status === 'Closed') {
              isDisabled = true
            } else {
              isDisabled = false
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: isDisabled
                },
                on: {
                  click: () => {
                    this.$router.push(
                      {
                        name: 'tech-rfps-messages',
                        query: { rfp: params.row.rfp_number }
                      }
                    )
                  }
                }
              }, 'Reply to RFP')
            ])
          }
        }
      ],
      tblData: []
    }
  },

  mounted () {
    this.getRfpsList()
  },

  watch: {
    searchText (val) {
      this.curPage = 1
      this.searchedText = val
      this.getRfpsList()
    }
  },

  methods: {
    getRfpsList () {
      this.isLoading = true
      let query = `?page=${this.curPage}`
      if (this.searchedText) query = query + `&keyword_search=${this.searchedText}`
      fetchRfps(query).then(res => {
        this.tblData = res.data.results
        this.totalData = res.data.count
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch rfp list: ', err)
        this.isLoading = false
      })
    },

    handleChangePage (pageNum) {
      this.curPage = pageNum
      this.getRfpsList()
    }
  }
}
</script>
